import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';

import { IconVerified, IconLeaf, IconStore, IconImpact } from './Icons';
import css from './SectionWhyEthy.module.css';

const CARDS = [
  {
    key: 'verified',
    Icon: IconVerified,
    titleId: 'LandingPage.why.verified.title',
    titleDefault: 'Claims checked against evidence',
    textId: 'LandingPage.why.verified.text',
    textDefault:
      "Every brand's sustainability claims are assessed against our published standards before it can sell on ethy.",
  },
  {
    key: 'sustainable',
    Icon: IconLeaf,
    titleId: 'LandingPage.why.sustainable.title',
    titleDefault: 'Verified credentials',
    textId: 'LandingPage.why.sustainable.text',
    textDefault:
      'Discover products with verified credentials in specific areas, such as recycled packaging, organic ingredients or UK manufacturing.',
  },
  {
    key: 'trusted',
    Icon: IconStore,
    titleId: 'LandingPage.why.trusted.title',
    titleDefault: 'Trusted brands',
    textId: 'LandingPage.why.trusted.text',
    textDefault:
      'Shop from a growing community of independent brands that share the evidence behind their claims.',
  },
  {
    key: 'impact',
    Icon: IconImpact,
    titleId: 'LandingPage.why.impact.title',
    titleDefault: 'Transparent credentials',
    textId: 'LandingPage.why.impact.text',
    textDefault:
      'See which specific sustainability criteria each product meets, and how we checked them.',
  },
];

/**
 * "Why Ethy" — a visual, card-based section that replaces the old text-heavy
 * "Why choose Ethy?" block.
 */
const SectionWhyEthy = () => {
  return (
    <section className={css.root}>
      <div className={css.inner}>
        <div className={css.heading}>
          <h2 className={css.title}>
            <FormattedMessage id="LandingPage.why.title" defaultMessage="Why ethy" />
          </h2>
          <p className={css.subtitle}>
            <FormattedMessage
              id="LandingPage.why.subtitle"
              defaultMessage="A marketplace built on transparency and evidence."
            />
          </p>
        </div>

        <ul className={css.grid}>
          {CARDS.map(({ key, Icon, titleId, titleDefault, textId, textDefault }) => (
            <li key={key} className={css.card}>
              <span className={css.iconWrap}>
                <Icon className={css.icon} />
              </span>
              <h3 className={css.cardTitle}>
                <FormattedMessage id={titleId} defaultMessage={titleDefault} />
              </h3>
              <p className={css.cardText}>
                <FormattedMessage id={textId} defaultMessage={textDefault} />
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default SectionWhyEthy;
